module.exports = __webpack_public_path__ + "img/stepup-mobile.3564db27.png";